document.addEventListener('DOMContentLoaded', function () {
  initRevealOnScroll();
  initAcordeonFaq();
  initContadores();
});

function initRevealOnScroll() {
  var items = document.querySelectorAll('.fp-reveal');
  if (!items.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) { el.classList.add('fp-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          var delay = entry.target.dataset.fpDelay || (i * 60);
          setTimeout(function () {
            entry.target.classList.add('fp-visible');
          }, delay);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  items.forEach(function (el) { observer.observe(el); });
}

function initAcordeonFaq() {
  var faqs = document.querySelectorAll('.fp-faq-item');
  if (!faqs.length) return;

  faqs.forEach(function (item) {
    var pregunta = item.querySelector('.fp-faq-pregunta');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('fp-faq-abierto');
      faqs.forEach(function (otro) { otro.classList.remove('fp-faq-abierto'); });
      if (!abierto) item.classList.add('fp-faq-abierto');
    });
  });
}

function initContadores() {
  var contadores = document.querySelectorAll('.fp-contador');
  if (!contadores.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var fin = parseFloat(el.dataset.fin || '0');
        var duracion = 1400;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / duracion, 1);
          var valor = Math.floor(progreso * fin);
          el.textContent = valor.toLocaleString();
          if (progreso < 1) requestAnimationFrame(paso);
          else el.textContent = fin.toLocaleString();
        }
        requestAnimationFrame(paso);
        observer.unobserve(el);
      });
    },
    { threshold: 0.5 }
  );

  contadores.forEach(function (el) { observer.observe(el); });
}
